import Video from './video.js';
export default Video;
